import { useMemo, useState } from "react";
import { Box, Flex, Icon, css } from "@storyofams/react-ui";
import { createClient } from "@supabase/supabase-js";
import { parse } from "date-fns";
import Image from "next/image";
import { useDate } from "~hooks";

import { LogoCompact, ThumbsUp } from "~components/common/Icons";
import { Text } from "../../../../components";

export const Question = ({
  author,
  body,
  answer,
  dateCreated,
  profileImageUrl,
  voteRating,
  id,
  isFirst,
  productId,
}) => {
  const [isOpenAnswer, setIsOpenAnswer] = useState(isFirst);
  const [likes, setLikes] = useState(0);
  const { formatDate } = useDate();
  const date =
    dateCreated?.length === 20 ? dateCreated : dateCreated?.slice(0, 19) + "Z";
  const shortName = useMemo(() => {
    const arr = author.split(" ");
    if (arr.length === 1) return author;
    return `${arr[0]} ${arr[1].slice(0, 1)}.`;
  }, [author]);
  const setRating = async (vote) => {
    const supabase = createClient(
      process.env.NEXT_PUBLIC_SUPABASE_URL,
      process.env.NEXT_PUBLIC_SUPABASE_KEY
    );
    try {
      const { error } = await supabase.from("product_questions").upsert({
        voteRating: vote + voteRating,
        id,
      });
      console.log(error);
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <Box
      width="100%"
      border={"1px solid grey200"}
      borderRadius={"8px"}
      py={["15px", "18px"]}
      px={["15px", "25px"]}
    >
      <Flex justifyContent="space-between">
        <Flex>
          <Box
            css={css({
              img: {
                borderRadius: "full",
              },
            })}
          >
            <Image
              width={28}
              height={28}
              unoptimized
              src={
                profileImageUrl ||
                "http://www.gravatar.com/avatar/df5c7c3db19f0a0ad9d075e52dee0a09?d=mm"
              }
            />
          </Box>

          <Text fontWeight={500} fontSize={"16px"} ml={"8px"} mr="15px">
            {shortName}
          </Text>
        </Flex>
        <Text color="grey600" fontWeight="medium" lineHeight={1} mb={3}>
          {formatDate(parse(date, "yyyy-MM-dd'T'HH:mm:ss'Z'", new Date()), {
            day: "numeric",
            month: "numeric",
            year: "numeric",
          })}
        </Text>
      </Flex>

      <Text mb={"7px"}>{body}</Text>
      <Flex width="100%" justifyContent="end" alignItems="center">
        {/* <Flex>
          <Icon mr={1} icon={Reaction}></Icon>
          <Text>Plaats reactie</Text>
        </Flex> */}
        <Flex>
          <Box
            as="button"
            onClick={() => {
              if (likes === 1) {
                setRating(0);
                setLikes(0);
              } else {
                setRating(1);
                setLikes(1);
              }
            }}
            p={1}
          >
            <Icon
              icon={ThumbsUp}
              fontSize={2.5}
              color={likes === 1 ? "oldPink" : "grey600"}
            />
          </Box>

          <Text minWidth={20} display="flex" justifyContent="center" pt={0.5}>
            {voteRating + likes}
          </Text>

          <Box
            as="button"
            onClick={() => {
              if (likes === -1) {
                setRating(0);
                setLikes(0);
              } else {
                setRating(-1);
                setLikes(-1);
              }
            }}
            p={1}
            pr={0}
          >
            <Icon
              icon={ThumbsUp}
              css={{ transform: "rotate(180deg)" }}
              fontSize={2.5}
              color={likes === -1 ? "oldPink" : "grey600"}
            />
          </Box>
        </Flex>
      </Flex>
      {!!answer && (
        <Box
          maxWidth={"690px"}
          py={"10px"}
          px={["15px", "20px"]}
          bg="#F4F3F0"
          borderRadius={"6px"}
        >
          <Flex
            cursor={"pointer"}
            onClick={() => setIsOpenAnswer((open) => !open)}
            width={"100%"}
            flexDirection={"column"}
            justifyContent={"center"}
            alignItems={"center"}
          >
            <Flex>
              <Text fontWeight={500} fontSize={"16px"} mr="8px">
                Antwoord
              </Text>
              <Box
                borderRadius="full"
                bg="grey800"
                color="white"
                ml={1}
                width={"24px"}
                height={"24px"}
                pl={"9px"}
                py={0.5}
                lineHeight={1}
              >
                1
              </Box>
            </Flex>
          </Flex>

          {isOpenAnswer && (
            <>
              <Flex justifySelf={"flex-start"} mt={["15px", "10px"]}>
                <Box
                  bg="white"
                  width={"28px"}
                  height={"28px"}
                  borderRadius={"full"}
                  pt={"1px"}
                  pl={"3px"}
                  mr="8px"
                >
                  <Icon icon={LogoCompact} fontSize={"23px"} />
                </Box>
                <Text fontWeight={500} fontSize="16px">
                  Natural Heroes
                </Text>
              </Flex>
              <Text mt={"15px"}>{answer}</Text>
            </>
          )}
        </Box>
      )}
    </Box>
  );
};
